const metaData = {
  fields: [
    'id',
    'product_id',
    'name',
    'mycenta_id',
    'description',
    'created_at',
    'updated_at',
    'created_by',
    'updated_by',
    'sections',
    'test_track_ids',
    'section_ids',
    { userByCreatedBy: ['displayName'] },
    { userByUpdatedBy: ['displayName'] },
    { paper_templates: ['name', 'id', 'active'] },
    'flagged_questions',
    { test_event: ['id', 'name'] },
    'tq',
    'type'
  ],
}

export default metaData
